import { useState } from 'react';
import { PHONE_DISPLAY, EMAIL, HOURS_LABEL } from '../../../lib/businessInfo';

const faqs = [
  {
    question: 'What are your hours of operation?',
    answer: `We're open ${HOURS_LABEL}. We recommend calling ahead to schedule a visit so we can give you our full attention.`
  },
  {
    question: 'Do I need an appointment to visit?',
    answer: 'While walk-ins are welcome, we highly recommend scheduling an appointment to ensure we have the vehicle you want to see ready and can dedicate time to answer all your questions.'
  },
  {
    question: 'How quickly do you respond to inquiries?',
    answer: 'We typically respond to phone calls immediately during business hours and emails within 2–4 hours. For urgent matters, calling is always fastest.'
  },
  {
    question: 'Can I get pre-approved for financing before visiting?',
    answer: "Absolutely! You can apply for financing online, and we'll work with our network of lenders to get you pre-approved before you even step foot on our lot."
  },
  {
    question: 'Do you offer vehicle delivery?',
    answer: 'Yes! We offer delivery throughout Southwest Washington and Northwest Oregon. Contact us for details about delivery to your specific location.'
  },
  {
    question: 'What if I have more questions after hours?',
    answer: `Feel free to email us at ${EMAIL} anytime, and we'll get back to you first thing the next business day. For urgent matters, you can also leave a voicemail at ${PHONE_DISPLAY}.`
  }
];

export default function ContactFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="bg-[#F7F5F0] py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-[#374151]">
            Quick answers to common questions about contacting us
          </p>
        </div>

        <div className="space-y-3" role="list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E8E2D6] overflow-hidden hover:border-[#E8B84B] transition-colors"
              role="listitem"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
                aria-controls={`contact-faq-answer-${index}`}
                id={`contact-faq-question-${index}`}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-[#FAFAF8] transition-colors cursor-pointer min-h-[52px] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#E8B84B]"
              >
                <span className="font-semibold text-[#1A2332] pr-4 text-sm sm:text-base">{faq.question}</span>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full bg-[#F0EDE6] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}
                  aria-hidden="true"
                >
                  <i className="ri-arrow-down-s-line text-xl text-[#1A2332]"></i>
                </div>
              </button>
              {openIndex === index && (
                <div
                  id={`contact-faq-answer-${index}`}
                  role="region"
                  aria-labelledby={`contact-faq-question-${index}`}
                  className="px-6 pb-5 pt-1 border-t border-[#E8E2D6]"
                >
                  <p className="text-[#374151] text-sm leading-relaxed pt-3">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
